"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "-3 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M1.34863 8H0.118164V0.890625H1.34863V8ZM2.86719 8V0.890625H4.9668C5.59505 0.890625 6.15169 1.0306 6.63672 1.31055C7.125 1.59049 7.5026 1.98763 7.76953 2.50195C8.03646 3.01628 8.16992 3.60547 8.16992 4.26953V4.62598C8.16992 5.2998 8.03483 5.89225 7.76465 6.40332C7.49772 6.91439 7.11523 7.30827 6.61719 7.58496C6.1224 7.86165 5.55436 8 4.91309 8H2.86719ZM4.10254 1.88672V7.01367H4.9082C5.55599 7.01367 6.05241 6.81185 6.39746 6.4082C6.74577 6.0013 6.92318 5.41862 6.92969 4.66016V4.26465C6.92969 3.49316 6.76204 2.90397 6.42676 2.49707C6.09147 2.09017 5.60482 1.88672 4.9668 1.88672H4.10254Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;